<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
        :error-alert-event="errorAlertEvent"
        :network-error="networkError"
        @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
        :show="showRefreshItem"
        @onRefresh="fetchInitialData"
    ></refresh-item>

    <credit-assessment-logs-item
        v-show="showCreditAssessmentLogsItem"
        ref="creditAssessmentLogsItem"
        @onNextClicked="onNextClickedInCreditAssessmentLogsItem"
    ></credit-assessment-logs-item>


  </div>
</template>

<script>
import Loading from "../layout/Loading";
import ToolBar from "../layout/ToolBar";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import StageCommentItem from "../layout/StageCommentItem";
import RefreshItem from "../layout/RefreshItem";
import LoanTasksUtility from "@/utils/LoanTasksUtility";
import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import EzUtils from "@/utils/EzUtils";
import CreditAssessmentLogsItem from "@/components/layout/CreditAssessmentLogsItem";
import LoanTasksActivityNavigator from "@/utils/LoanTasksActivityNavigator";

export default {
  name: "BureauDetailsProvider",
  components: {
    ToolBar,
    ErrorAlertItem,
    Loading,
    StageCommentItem,
    RefreshItem,
    CreditAssessmentLogsItem
  },

  data: () => ({
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,

    bureauType: "", //type in credit_assessment_log, type in query_details
    bureauReportName: "", //pdf document name (report pdf)
    bureauBand: "", //top message color coding in bureau details
    bureauBandMessage: "", //top message in bureau details
    keepLayoutExpanded: false,

    showCreditAssessmentLogsItem: false

  }),

  props: {
    bureauReportHeading: {
      type: String,
      default: "Details of Bureau Report Analysis"
    },

    toolbarTitle: {
      type: String,
      default: "Bureau Summary"
    },
  },

  methods: {

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onNextClickedInCreditAssessmentLogsItem() {
      this.completeCurrentTaskAndGetNextTask();
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask([this.currentTaskName])
      .then(res => {
        this.loading = false;
        if (res.errorOccurred) {
          this.showError(res.data);
        }
      });
    },

    showCreditAssessmentLogsItemLayout() {
      this.showCreditAssessmentLogsItem = true;
      this.$refs.creditAssessmentLogsItem.showCreditAssessmentLogsExternal(
          this.bureauReportHeading,
          this.bureauType,
          this.bureauBand,
          this.bureauBandMessage,
          this.bureauReportName
      )
    },

    fetchInitialData() {
      this.showRefreshItem = false;

      this.loading = true;
      LoanTasksUtility.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
      .then(stageConfigRes => {
        this.loading = false;
        if (stageConfigRes.errorOccurred) {
          this.showRefreshItem = true;
          this.showError(stageConfigRes.data);
        } else {
          const stageConfig = stageConfigRes.data;

          this.bureauType = EzUtils.getValueFromObject(stageConfig, "type", "");
          this.bureauReportName = EzUtils.getValueFromObject(stageConfig, "bureauReportName", "");
          this.bureauBand = EzUtils.getValueFromObject(stageConfig, "bureauBand", "");
          this.bureauBandMessage = EzUtils.getValueFromObject(
              stageConfig, "bureauBandMessage", ""
          );
          this.keepLayoutExpanded = EzUtils.getValueFromObject(
              stageConfig, "keepLayoutExpanded", false
          );

          this.showCreditAssessmentLogsItemLayout();
        }
      })
    }
  },

  mounted() {
    this.fetchInitialData();
  },

  computed: {
    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name
          : "";
    },

  },
};
</script>

<style src="../../assets/style/base.css"></style>
